import { IComponentChildrenProps } from '@src/models/props';
import React, { createContext, FC, useContext, useMemo } from 'react';
import { getFeatureFlagsFromLS } from './utils';

interface IFeatureFlags {
  [x: string]: boolean;
}
interface IFeatureFlagsProps {
  featureFlags: IFeatureFlags;
}

interface IFeatureContext extends IFeatureFlagsProps {
  /** @deprecated не используй в компонентах, только для провайдера */
  _getParentFeatureFlags: () => IFeatureFlags;
}

export const FeatureContext = createContext<IFeatureContext>({
  featureFlags: {},
  _getParentFeatureFlags: () => ({}),
});

interface IFeatureProviderProps extends IComponentChildrenProps, IFeatureFlagsProps {}

/*
  Повзаляет передовать объект с названиями фич и их состоянием.
  Так же имеет возможность получать этот объект из LocalStorage
  @link https://centrateam.atlassian.net/wiki/spaces/CEN/pages/114950189
*/
export const FeatureProvider: FC<IFeatureProviderProps> = ({ featureFlags: featureFlagsProps, children }) => {
  const { _getParentFeatureFlags } = useContext(FeatureContext);
  const value = useMemo<IFeatureContext>(() => {
    const localStorageFlags = getFeatureFlagsFromLS();

    const featureFlags = {
      ...localStorageFlags,
      ..._getParentFeatureFlags(),
      ...featureFlagsProps,
    };

    return {
      featureFlags,
      _getParentFeatureFlags: () => featureFlags,
    };
  }, [_getParentFeatureFlags, featureFlagsProps]);

  return <FeatureContext.Provider value={value}>{children}</FeatureContext.Provider>;
};
